import { useSelector } from '@/libs/state'
import { makeSetTheme } from '../application/set-theme'
import { themePort } from '../wiring'
import { theme$ } from '../store'
import type { Theme } from '../domain/theme'

const applyTheme = makeSetTheme(themePort)

const resolveTheme = (theme: Theme): 'light' | 'dark' =>
	theme === 'system'
		? window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
		: theme

const useTheme = () => {
	const theme = useSelector(() => theme$.get())

	const setTheme = (next: Theme) => {
		applyTheme(next)
		theme$.set(next)
	}

	return { theme, resolvedTheme: resolveTheme(theme), setTheme }
}

export { useTheme }
